import React from 'react'; 
import ReactDOM from 'react-dom/client'; 
import App from './App';
import './styles/index.scss'
import './styles/cards.scss'
import './styles/skills.scss'
import './styles/text.scss'
import './styles/buttons.scss'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);